import { render, staticRenderFns } from "./ConfirmUser.vue?vue&type=template&id=3b7b4d52&scoped=true&"
import script from "./ConfirmUser.vue?vue&type=script&lang=js&"
export * from "./ConfirmUser.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmUser.vue?vue&type=style&index=0&id=3b7b4d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7b4d52",
  null
  
)

export default component.exports